import type { AuthClient } from './AuthClient';
import { SimulatedAuthClient } from './SimulatedAuthClient';

/**
 * The single place that decides which authentication provider the application runs against.
 *
 * Introducing a real provider means adding one `AuthClient` implementation and one branch here,
 * selected through `VITE_AUTH_PROVIDER`. No other module imports a concrete client.
 */
export const createAuthClient = (): AuthClient => {
    const provider = import.meta.env.VITE_AUTH_PROVIDER ?? 'simulated';

    switch (provider) {
        case 'simulated':
            return new SimulatedAuthClient(window.localStorage);
        default:
            throw new Error(`Unsupported authentication provider: ${provider}`);
    }
};
